/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Name"
  
}) {
let appointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'type.display_name',
})
let appointmentValueData = fromData.useDataFormat({ viewPath,
context: 'appointment',
format: fromFormat.isAppointmentScheduled,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="appointment.type.display_name"
 text={appointmentTypeDisplayNameValueData}
 weight="medium"
 size="large"
 color={appointmentValueData ? dtColorsNeutral900 : dtColorsNeutral500}
 data="appointment"
 format="/Data/format.js isAppointmentScheduled"
/>
{children}
</React.Fragment>)
}